import { Option } from "../../models/option";

export const tournamentMaxTeams: Option[] = [
  {value: 32},
  {value: 64},
];